import * as actions from "../action.constants";

const requestInventoriesList = () => ({
  type: actions.REQUEST_INVENTORIES_VALUE_LIST,
});

const requestInventories = (pageUrl = "", trackPromise = true) => ({
  type: actions.REQUEST_INVENTORIES_SAGA,
  pageUrl,
  trackPromise,
});

export {requestInventories, requestInventoriesList};
